import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "./TermsSection.css";

import bgImage from "../../assets/Institute/DSC_0110.JPG";
import overlay1 from "../../assets/cta.avif";
import overlay2 from "../../assets/cta.avif";
import overlay3 from "../../assets/cta.avif";

const PioneersSection1 = () => {
  const [count, setCount] = useState({ teachers: 0, schools: 0, years: 0 });

  useEffect(() => {
    let start = 0;
    const interval = setInterval(() => {
      start++;
      if (start <= 5500)
        setCount({
          teachers: start,
          schools: Math.floor(start / 20),
          years: Math.floor(start / 275),
        });
      else clearInterval(interval);
    }, 1);
    return () => clearInterval(interval);
  }, []);

  return (
    <section
      className="pioneers-revamp-1"
      id="pioneers-1"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="overlay-1"></div>

      <div className="pioneers-content-1">
        <motion.div
          className="pioneers-text-1"
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h2>1. Introduction</h2>
          <p>Welcome to NIECCE Edu Solutions Pvt Ltd. These Terms and Conditions govern your use of our website and services. By accessing our website, enrolling in our teacher training programs, or using our book publishing services, you agree to these Terms and Conditions in full. If you disagree with any part of these terms, please do not use our website or services.</p>
          <h3>2. Copyright and Intellectual Property</h3>
          <p>All content published and made available on our site, including texts, graphics, logos, images, and educational material, is the property of NIECCE Edu Solutions Pvt Ltd and/or its content creators. This content cannot be copied, reproduced, or used in any manner without the express written permission of the copyright holder.</p>
          <h3>3. Service Descriptions</h3>
          <p>We provide detailed descriptions of our teacher training programs and book publishing services on our website. While we strive for accuracy, errors or inaccuracies may occur, for which we are not liable.</p>
          <h3>4. User Accounts</h3>
          <p>When you create an account on our website, you agree to provide accurate and up-to-date information. You are responsible for maintaining the confidentiality of your account and password and for all activities under your account.</p>
          <h3>5. Payments and Fees</h3>
          <p>Details of the fees for our services are available on our website. We reserve the right to change these fees at any time.</p>
          <h3>6. Cancellation and Refund Policy</h3>
          <p>Please refer to our specific cancellation and refund policy for details on how to cancel services and eligibility for refunds.</p>
          <h3>7. Limitation of Liability</h3>
          <p>NIECCE Edu Solutions Pvt Ltd and its employees shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of our website or services.</p>
          <h3>8. Governing Law</h3>
          <p>These terms and conditions are governed by the laws of the country/state in which we operate. Any disputes related to these terms will be subject to the jurisdiction of the courts of this country/state.</p>
          <h3>9. Changes to These Terms</h3>
          <p>We reserve the right to modify these terms at any time. Any changes will be effective immediately upon posting to the website.</p>
          <h3>10. Contact Information</h3>
          <p>For any questions or concerns about these terms, please contact us at <b>info@niecce.com</b></p>
        </motion.div>

        
      </div>
    </section>
  );
};

export default PioneersSection1;
